import React, { useMemo } from 'react';
import SliderImport from 'rc-slider';
import 'rc-slider/assets/index.css';
import styles from './Slider.module.scss';
const RCSlider = SliderImport;
const createHandleRenderer = (step)=>{
    const valueDecimalsFromStep = useMemo(()=>{
        const stepStr = String(step);
        const decimalIndex = stepStr.indexOf('.');
        if (decimalIndex < 0) return 0;
        return stepStr.length - decimalIndex - 1;
    }, [
        step
    ]);
    return (origin, props)=>/*#__PURE__*/ React.createElement("div", origin.props, /*#__PURE__*/ React.createElement("span", {
            className: styles.handleValue
        }, props.value.toFixed(valueDecimalsFromStep)));
};
export const Slider = ({ value, onChange, min, max, step = 1 })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.sliderContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.minMaxLabel
    }, min), /*#__PURE__*/ React.createElement("div", {
        className: styles.track
    }, /*#__PURE__*/ React.createElement(RCSlider, {
        className: styles.sliderWrapper,
        handleRender: createHandleRenderer(step),
        max: max,
        min: min,
        onChange: onChange,
        step: step,
        value: value
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.minMaxLabel
    }, max));
